import React from 'react';
import CandidatoAvatar from '../../components/CandidatoAvatar';
import { capitalize } from './constants';
import RadarChart from './RadarChart';

export default function PoliticoHoverCard({ politico, label, position, extraInfo }) {
  if (!politico) return null;
  const style = position
    ? { position: 'fixed', left: position.x + 16, top: position.y - 10, zIndex: 50 }
    : {};

  const ind = politico.indicadores;
  const radarStats = ind ? [ind.carisma, ind.influencia, ind.recursos, ind.risco] : null;

  return (
    <div className="politico-hover-card" style={style}>
      <p className="politico-hover-card__label">{label}</p>
      <div className="politico-hover-card__row">
        <CandidatoAvatar candidato={politico} foto={politico.foto} nome={politico.nome} size={44} />
        <div className="politico-hover-card__info">
          <p className="politico-hover-card__name">{politico.nome}</p>
          <p className="politico-hover-card__full-name">{capitalize(politico.nomeCompleto)}</p>
          <div className="politico-hover-card__badges">
            <span className="politico-hover-card__party">{politico.partido}</span>
            {politico.ocupacao && politico.ocupacao !== '#NULO' && (
              <span className="politico-hover-card__occupation">{capitalize(politico.ocupacao)}</span>
            )}
          </div>
          {extraInfo && (
            <p className="politico-hover-card__extra">{extraInfo}</p>
          )}
        </div>
      </div>
      {radarStats && (
        <div className="mt-2 pt-2 border-t border-white/[.06] flex justify-center">
          <RadarChart stats={radarStats} size={110} color="#d4a574" />
        </div>
      )}
    </div>
  );
}
